@if (nakymanAsetuksetObservable | async; as nakymanAsetukset) {
  <div>
    @if (nakymanAsetukset.naytaListaus) {
      <div class="list-page maksut list-loading" style="max-width: 1050px">
        <div class="topButtons">
          <div class="search">
            <mat-form-field>
              <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
              <mat-label>{{ 'laskut.etsi' | translate | async }}</mat-label>
              <input type="text" matInput readonly (click)="avaaHaku()" style="cursor: pointer" [attr.aria-label]="'tositteet.avaa-haku' | translate | async" />
            </mat-form-field>
          </div>
          <mat-tab-group style="margin-top: 2px" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="tabChanged($event)">
            <mat-tab [label]="'maksut.avoimet' | translate | async"> </mat-tab>
            <mat-tab [label]="'maksut.kaikki' | translate | async"> </mat-tab>
          </mat-tab-group>
          <div class="addButton" style="padding-top: 7px">
            @if (nakymanAsetukset.naytaLisaaButton) {
              <button mat-button (click)="naytaTiedostonValintaDialogi()" type="button" class="primarybutton mat-elevation-z4">
                <mat-icon>add</mat-icon>
                {{ 'maksut.lisaa' | translate | async }}
              </button>
            }
          </div>
        </div>
        <form>
          @if (nakymanAsetukset.naytaLaskujenVastaanottoEiPaallaTeksti) {
            <div class="warning-msg red-text">
              {{ 'maksut.et-vastaanota-laskuja' | translate | async }}<span (click)="navigateToSettings()" class="link-like">{{ 'maksut.tasta' | translate | async }}.</span>
            </div>
          }
          <!-- <div class="hakukontrollit">
          <mat-form-field floatPlaceholder="never">
            <mat-label>{{ 'maksut.nayta' | translate | async }}</mat-label>
            <mat-select  formControlName="tila">
              <mat-option *ngFor="let tila of laskunTilatObservable | async" [value]="tila.tunnus">
                {{ tila.nimi }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'maksut.etsi' | translate | async }}</mat-label>
            <input type="text" [name]="name" formControlName="nimiFirestore"  matInput />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'maksut.rajaa-kuukauden-mukaan' | translate | async }}</mat-label>
            <input matInput [name]="name" [matDatepicker]="dp"  formControlName="vuosikk">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp startView="year" (monthSelected)="chosenMonthHandler($event, dp)" panelClass="kuukausi-valitsin"></mat-datepicker>
          </mat-form-field>
        </div> -->
          <!-- </form> -->
          @if (nakymanAsetukset.valittuTab === 'avoimet' && (avoinnaTo() || avoinnaTo() == 0)) {
            <div class="summatContainer">
              <div class="summat">
                @if (latestBankBalanceObservable | async; as latestBankBalance) {
                  <div>
                    <!-- <div>{{tilinSaldoFrom}} -> {{tilinSaldoTo}}</div> -->
                    <div class="otsikko">{{ 'maksut.summat.tilin-saldo' | translate | async }}</div>
                    <div class="maara" appCountTo [step]="16.667" [countTo]="latestBankBalance.balance" [countFrom]="tilinSaldoFrom" [duration]="1" (countToChange)="countToTilinSaldo = $event" (countToEnd)="onCountToEnd()">{{ countToTilinSaldo | lmoney: valuutta | async }}</div>
                    <div class="kommentti">{{ latestBankBalance.iban }}<br />{{ 'maksut.summat.paivitetty' | translate | async }} {{ latestBankBalance.fetchTime | ltimestamptime | async }}</div>
                  </div>
                }
                <div>
                  <!-- <div>{{avoinnaFrom}} -> {{avoinnaTo}}</div> -->
                  <div class="otsikko">{{ 'maksut.summat.avoinna' | translate | async }}</div>
                  <div class="maara blue-text" appCountTo [step]="16.667" [countTo]="avoinnaTo()" [countFrom]="avoinnaFrom" [duration]="1" (countToChange)="countToAvoinna = $event" (countToEnd)="onCountToEnd()">{{ countToAvoinna | lmoney: valuutta | async }}</div>
                </div>
                <div>
                  <!-- <div>{{eraantynytFrom}} -> {{eraantynytTo}}</div> -->
                  <div class="otsikko">{{ 'maksut.summat.eraantynyt' | translate | async }}</div>
                  <div class="maara red-text" [class.red-text]="eraantynytTo() != 0" [class.green-text]="eraantynytTo() == 0" appCountTo [step]="16.667" [countTo]="eraantynytTo()" [countFrom]="eraantynytFrom" [duration]="1" (countToChange)="countToEraantynyt = $event" (countToEnd)="onCountToEnd()">
                    {{ countToEraantynyt | lmoney: valuutta | async }}
                  </div>
                </div>
                <!-- <div class="huomautukset">
            <span *ngIf="naytaHuomautus" style="margin-left: 2em;" (click)="avaaHuomautus()">{{'maksut.summat.huomautus' | translate | async}}</span>
          </div> -->
              </div>
            </div>
          }
          @if (nakymanAsetukset.valittuTab === 'kaikki') {
            <form style="background-color: rgba(242, 242, 242); border-radius: 5px; padding: 15px; margin-bottom: 15px">
              <div style="display: flex; justify-content: right">
                <mat-radio-group [formField]="kaikkiHakuLomake.pvmTyyppi" style="display: flex; gap: 10px">
                  <mat-radio-button color="primary" [value]="KaikkiHakuFormPvmTyyppi.LASKU">{{ 'maksut.laskun-pvm' | translate | async }}</mat-radio-button>
                  <mat-radio-button color="primary" [value]="KaikkiHakuFormPvmTyyppi.MAKSU">{{ 'maksut.maksun-pvm' | translate | async }}</mat-radio-button>
                </mat-radio-group>
              </div>
              <div style="display: flex; gap: 20px">
                <mat-form-field>
                  <mat-label>{{ 'maksut.tila' | translate | async }}</mat-label>
                  <mat-select [formField]="kaikkiHakuLomake.tila" style="width: 100%">
                    @for (tila of maksunTilatObservable | async; track tila) {
                      <mat-option [value]="tila.tunnus">
                        {{ tila.nimi }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ 'maksut.muokkaa.toimittaja' | translate | async }}</mat-label>
                  <input #toimittajaVar="matInput" type="text" autocomplete="toimittaja" [matAutocomplete]="toimittajaAuto" [formField]="kaikkiHakuLomake.toimittaja" matInput data-lpignore="true" />
                  <mat-autocomplete #toimittajaAuto="matAutocomplete" [displayWith]="toimittajaDisplayFn" [panelWidth]="350">
                    @for (toimittaja of suodatetutToimittajat | async; track toimittaja) {
                      <mat-option [value]="toimittaja"> {{ toimittaja.numero }} {{ toimittaja.nimi }} {{ toimittaja.ytunnus ? `(${naytettavaTunniste(toimittaja.ytunnus)})` : '' }} </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Alkaa</mat-label>
                  <input type="text" [matDatepicker]="alkaaPicker" [formField]="kaikkiHakuLomake.alku" matInput data-lpignore="true" />
                  <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle>
                  <mat-datepicker #alkaaPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Loppuu</mat-label>
                  <input type="text" [matDatepicker]="loppuuPicker" [formField]="kaikkiHakuLomake.loppu" matInput data-lpignore="true" />
                  <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
                  <mat-datepicker #loppuuPicker></mat-datepicker>
                </mat-form-field>
              </div>
            </form>
          }
          <div style="max-width: 800px; margin: 0 auto">
            <div style="position: relative; min-height: 250px; overflow-x: auto; margin: 0 5px; text-align: center">
              @if (nakyvatRivitObservable | async; as nakyvatRivit) {
                <table class="maksut-table" matSort [matSortDisableClear]="true" style="border-spacing: 0; margin: 0 auto; text-align: left">
                  <thead>
                    <tr class="mat-mdc-header-row">
                      @if (nakymanAsetukset.valittuTab === 'avoimet' && nakymanAsetukset.viewType !== 'vastaanotto') {
                        <th class="mat-mdc-header-cell mat-column-valinta">
                          @if (nakymanAsetukset.valittuTab === 'avoimet' && nakymanAsetukset.viewType === 'maksaminen') {
                            <mat-checkbox #selectAllCheckbox (change)="maksuAllSelectionChanged(nakyvatRivit, $event)"> </mat-checkbox>
                          }
                        </th>
                      }
                      <!-- mat-sort-header="tila" -->
                      <!-- mat-sort-header="asiakas" -->
                      <!-- mat-sort-header="sum" -->
                      @if (nakymanAsetukset.valittuTab === 'avoimet' && nakymanAsetukset.viewType !== 'vastaanotto' && nakymanAsetukset.vaatiiHyvaksynnan) {
                        <th class="mat-mdc-header-cell mat-column-tila">{{ 'maksut.hyvaksytty' | translate | async }}</th>
                      }
                      <th class="mat-mdc-header-cell mat-column-tila">{{ 'maksut.tila' | translate | async }}</th>
                      <th class="mat-mdc-header-cell mat-column-tila">{{ 'maksut.muokkaa.toimittaja' | translate | async }}</th>
                      <th class="mat-mdc-header-cell mat-column-asiakas">{{ 'maksut.maksun-saaja' | translate | async }}</th>
                      @if (nakymanAsetukset.valittuTab === 'avoimet') {
                        <th mat-sort-header="dueDate" class="mat-mdc-header-cell mat-column-erapvm">{{ 'maksut.erapaiva' | translate | async }}</th>
                      }
                      @if (nakymanAsetukset.valittuTab === 'kaikki') {
                        <th class="mat-mdc-header-cell mat-column-pvm">{{ 'maksut.laskun-pvm' | translate | async }}</th>
                      }
                      @if (nakymanAsetukset.valittuTab === 'kaikki') {
                        <th class="mat-mdc-header-cell mat-column-maksupvm">{{ 'maksut.maksun-pvm' | translate | async }}</th>
                      }
                      <th class="mat-mdc-header-cell mat-column-summa align-header-right">{{ 'maksut.summa' | translate | async }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <ng-container *ngFor="let row of nakyvatRivitObservable | async"> -->
                    <!-- [class.error]="row.virhe" -->
                    @for (row of nakyvatRivit; track row) {
                      <tr class="mat-mdc-row vanhempi" [class.has-change]="row.maksunsaajaChanged || row.erapaivaChanged || row.summaChanged">
                        @if (nakymanAsetukset.valittuTab === 'avoimet' && nakymanAsetukset.viewType !== 'vastaanotto') {
                          <td class="mat-mdc-cell mat-column-valinta">
                            <!-- [class.blue-text]="row.vari == 'blue'" [class.yellow-text]="row.vari == 'yellow'" [class.green-text]="row.vari == 'green'" [class.red-text]="row.vari == 'red'" [class.purple-text]="row.vari == 'purple'" [class.mint-text]="row.vari == 'mint'" -->
                            <div [matTooltip]="row.voidaanValita ? null : row.valintaOhjeistus" style="display: flex">
                              @if (nakymanAsetukset.viewType === 'maksaminen' && row.naytaValinta) {
                                <mat-checkbox [disabled]="!row.voidaanValita" [checked]="row.valittu" (change)="maksuSelectionChanged(row, nakyvatRivit, $event)" style="margin-top: -4px; display: inline-flex"> </mat-checkbox>
                              }
                            </div>
                          </td>
                        }
                        <!-- [class.purple-text]="row.vari == 'purple'" [class.yellow-text]="row.vari == 'yellow'" -->
                        @if (nakymanAsetukset.valittuTab === 'avoimet' && nakymanAsetukset.viewType !== 'vastaanotto' && nakymanAsetukset.vaatiiHyvaksynnan) {
                          <td class="mat-mdc-cell mat-column-hyvaksytty" (click)="katsele(row)">
                            @if (row.maksuHyvaksytty) {
                              <i class="icon ion-ios-checkmark" style="font-size: 40px; color: #2a8ff4"></i>
                            }
                          </td>
                        }
                        <td
                          class="mat-mdc-cell mat-column-tila"
                          (click)="katsele(row)"
                          [class.blue-text]="row.paymentStatus === PaymentStatus.AVOIN"
                          [class.green-text]="row.paymentStatus === PaymentStatus.MAKSETTU || row.paymentStatus == PaymentStatus.MAKSETTU_TOISAALLA"
                          [class.red-text]="row.paymentStatus === PaymentStatus.ERAANTYNYT || row.paymentStatus === PaymentStatus.PANKKI_HYLKASI"
                          [class.mint-text]="row.paymentStatus == PaymentStatus.MAKSUSSA"
                        >
                          {{ 'maksut.tilat.' + row.paymentStatus | translate | async }}
                          @if (row.virhe) {
                            <span [matTooltip]="row.virheviesti" style="text-align: center; margin-left: 5px; font-size: 32px; font-weight: bold; vertical-align: middle; padding-right: 4px; border-bottom: none">
                              <mat-icon>info_outline</mat-icon>
                            </span>
                          }
                        </td>
                        <td class="mat-mdc-cell mat-column-toimittaja" (click)="katsele(row)">
                          @if (row.toimittaja) {
                            <span>{{ row.toimittaja.numero }}</span>
                          }
                        </td>
                        <td class="mat-mdc-cell mat-column-asiakas" (click)="katsele(row)">
                          <span [class.strike]="row.maksunsaajaChanged">{{ row.seller }}</span>
                          @if (row.maksunsaajaChanged) {
                            <br /><span>{{ row.maksutiedot.maksunSaajanNimi }}</span>
                          }
                        </td>
                        @if (nakymanAsetukset.valittuTab === 'avoimet') {
                          <td class="mat-mdc-cell mat-column-erapvm" (click)="katsele(row)">
                            <span [class.strike]="row.erapaivaChanged">{{ row.dueDate | lnumberpvm | async }}</span>
                            @if (row.erapaivaChanged) {
                              <br /><span>{{ row.maksutiedot.dueDate | lnumberpvm | async }}</span>
                            }
                          </td>
                        }
                        @if (nakymanAsetukset.valittuTab === 'kaikki') {
                          <td class="mat-mdc-cell mat-column-pvm" (click)="katsele(row)">
                            <span>{{ row.p | lnumberpvm | async }}</span>
                          </td>
                        }
                        @if (nakymanAsetukset.valittuTab === 'kaikki') {
                          <td class="mat-mdc-cell mat-column-maksupvm" (click)="katsele(row)">
                            <span>{{ row.paymentDate | lnumberpvm | async }}</span>
                          </td>
                        }
                        <td class="mat-mdc-cell mat-column-summa" (click)="katsele(row)">
                          <span [class.strike]="row.summaChanged">{{ row.sum | lmoney: row.currency ?? 'EUR' | async }}</span>
                          @if (row.summaChanged) {
                            <br /><span>{{ row.maksutiedot.amount | lmoney: row.currency ?? 'EUR' | async }}</span>
                          }
                        </td>
                      </tr>
                    }
                    <!-- <tr class="lapsi" *ngIf="row.virhe">
                <td *ngIf="nakymanAsetukset.viewType !== 'vastaanotto'"></td>
                <td colspan="4" class="mat-mdc-cell red-text">
                  {{ 'maksut.maksu-hylkaamisen-syy' | translate | async }}: {{ ('maksut.maksu-epaonnistui-' + (row.paymentRejection?.reason ?? '1')) | translate | async }}
                  {{ row.paymentRejection?.reason === PaymentRejectionReason.UNKNOWN ? '(' + row.paymentRejection.rawText + ')' : ''}}
                </td>
              </tr>
            </ng-container> -->
                  </tbody>
                  <tfoot>
                    @for (rivi of yhteensaRivitObservable | async; track rivi) {
                      <tr class="mat-mdc-footer-row dark-gray-text">
                        @if (nakymanAsetukset.viewType !== 'vastaanotto') {
                          <td class="mat-mdc-footer-cell" style="border-bottom-color: transparent">&nbsp;</td>
                        }
                        <td class="mat-mdc-footer-cell mat-column-asiakas" style="border-bottom-color: transparent; text-align: right; padding-right: 10px" colspan="3">{{ 'maksut.nakyvat-rivit-yhteensa' | translate | async }}:</td>
                        <td class="mat-mdc-footer-cell mat-column-summa" style="border-bottom-color: transparent">{{ rivi.yhteensa | lmoney: rivi.valuutta | async }}</td>
                      </tr>
                    }
                  </tfoot>
                </table>
              }
              @if (lataaObservable | async) {
                <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-items: center; align-items: center">
                  <div lemon-loading [config]="loadingSettings" [show]="true"></div>
                </div>
              }
              @if (naytaEiYhtaanObservable | async) {
                <div class="table-ladataan" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; text-align: center; display: flex; justify-content: center; align-items: center">
                  <ng-container>
                    @if (nakymanAsetukset.valittuTab === 'avoimet') {
                      <div class="gray-text">
                        <i class="icon ion-ios-checkmark-circle-outline" style="font-size: 125px"></i><br />
                        {{ 'maksut.hakuehdoilla-ei-yhtaan-tulosta' | translate | async }}
                      </div>
                    }
                    @if (nakymanAsetukset.valittuTab === 'kaikki') {
                      <div>{{ 'maksut.hakuehdoilla-ei-yhtaan-tulosta-historia' | translate | async }}</div>
                    }
                  </ng-container>
                </div>
              }
            </div>
            @if (kokonaismaaraObservable | async; as maaraObject) {
              <div style="overflow-x: auto; margin: 0 5px">
                <mat-paginator #paginator="matPaginator" [ngStyle]="{ display: maaraObject.maara < dataSource?.page?.pageSize ? 'none' : 'initial' }" [length]="maaraObject.maara" [pageSize]="dataSource?.page?.pageSize" [pageIndex]="dataSource?.page?.pageIndex" [pageSizeOptions]="[100, 200]"></mat-paginator>
                @if (maaraObject.maara > 0) {
                  <div style="text-align: right; font-size: 80%; color: rgba(0, 0, 0, 0.54); margin-right: 25px">{{ paginator.pageSize * paginator.pageIndex + 1 }} - {{ paginator.pageSize * (paginator.pageIndex + 1) > maaraObject.maara ? maaraObject.maara : paginator.pageSize * (paginator.pageIndex + 1) }} / {{ maaraObject.maara }}</div>
                }
              </div>
            }
          </div>
          @if (valittujenTositteidenMaaraObservable | async) {
            <div style="position: sticky; bottom: 5px; display: flex">
              <div class="mat-elevation-z3" style="border-radius: 25px; padding: 15px 15px; padding-top: 0; margin-left: auto; margin-right: auto; background-color: white">
                <div style="display: flex; align-items: center">
                  <div class="summat" style="margin: 10px; flex-flow: column; width: unset; padding: unset">
                    <div class="otsikko" style="margin: 0">{{ valittujenTositteidenMaaraObservable | async }} {{ 'maksut.laskua-yhteensa' | translate | async }}</div>
                    <div class="maara" style="margin: 0">{{ valittujenTositteidenSummaObservable | async | lmoney: 'EUR' | async }}</div>
                  </div>
                  <button style="margin: 10px; margin-top: 26px; padding-left: 18px" class="primarybutton" (click)="maksaErapaivana()" mat-button>{{ 'maksut.maksa-erapaivana' | translate | async }}</button>
                  <button style="margin: 10px; margin-top: 26px" class="secondarybutton" (click)="maksaHeti()" mat-button>{{ 'maksut.maksa-heti' | translate | async }}</button>
                </div>
                @if (paymentConfigsObservable | async; as paymentConfigs) {
                  @if (paymentConfigs?.length > 1) {
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <div style="margin-right: 10px">{{ 'maksut.maksutili' | translate | async }}:</div>
                      <div>
                        <mat-select [formField]="maksutiliLomake.config" [compareWith]="compareConfigs">
                          @for (config of paymentConfigs; track config) {
                            <mat-option [value]="config">{{ config.pankki }} {{ config.iban }}</mat-option>
                          }
                        </mat-select>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </form>
      </div>
    } @else {
      <div app-maksut-mainos></div>
    }
  </div>
} @else {
  <div style="height: 100vh; width: 100%; padding: 0 20%; display: flex; align-items: center; justify-content: center; flex-direction: column">
    <div>{{ 'yleiset.ladataan' | translate | async }}...</div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" #fileInput multiple="multiple" />
<!-- accept="image/*,application/pdf" -->

<app-tosite-haku [avoinna]="hakuAvoinna" oletusTositelaji="ostolaskut" (suljettu)="suljeHaku()"></app-tosite-haku>
